/**
 * Örnek üye listesinden detay görünüm modeli (simülasyon).
 * @param {import('../data/members').ClubMember} m
 * @param {{ viewAsPartner?: boolean }} [opts]
 */
export function mapClubMemberToDetailView(m, opts = {}) {
    const viewAsPartner = opts.viewAsPartner === true && Boolean(m.partnerId);

    if (viewAsPartner) {
        const partnerName =
            `${m.partnerGivenName ?? ''} ${m.partnerFamilyName ?? ''}`.trim();
        const mainName = `${m.givenName} ${m.familyName}`.trim();
        return {
            id: m.partnerId,
            fullName: partnerName,
            email: '',
            phoneNumber: '',
            jobTitle: '',
            company: '',
            sector: '',
            university: null,
            highSchool: null,
            address: '',
            workAddress: '',
            profilePictureUrl: m.partnerProfilePictureUrl || '',
            birthDate: null,
            clubJoinDate: null,
            website: null,
            hobbies: null,
            facebook: null,
            twitter: null,
            linkedIn: null,
            membershipType: null,
            referenceMemberId: m.id,
            isPartnerProfile: true,
            spouses: [
                {
                    id: m.id,
                    fullName: mainName,
                    email: (m.email || '').trim(),
                    phoneNumber: '',
                    jobTitle: (m.profession || '').trim(),
                    company: (m.company || '').trim(),
                    birthDate: m.birthDate ? `${m.birthDate}T12:00:00` : null,
                    profilePictureUrl: m.profilePictureUrl || '',
                },
            ],
            children: [],
            groupLeader: false,
            partnerGivenName: undefined,
            partnerFamilyName: undefined,
            partnerProfilePictureUrl: undefined,
        };
    }

    return {
        id: m.id,
        fullName: `${m.givenName} ${m.familyName}`.trim(),
        email: (m.email || '').trim(),
        phoneNumber: '',
        jobTitle: (m.profession || '').trim(),
        company: (m.company || '').trim(),
        sector: (m.sector || '').trim(),
        university: null,
        highSchool: null,
        address: '',
        workAddress: '',
        profilePictureUrl: m.profilePictureUrl || '',
        birthDate: m.birthDate ? `${m.birthDate}T12:00:00` : null,
        clubJoinDate: m.joinedAt ? `${m.joinedAt}T12:00:00` : null,
        website: null,
        hobbies: null,
        facebook: null,
        twitter: null,
        linkedIn: null,
        membershipType: null,
        referenceMemberId: null,
        isPartnerProfile: false,
        spouses:
            m.partnerId && m.partnerGivenName && m.partnerFamilyName
                ? [
                      {
                          id: m.partnerId,
                          fullName: `${m.partnerGivenName} ${m.partnerFamilyName}`.trim(),
                          email: '',
                          phoneNumber: '',
                          jobTitle: '',
                          company: '',
                          birthDate: null,
                          profilePictureUrl:
                              m.partnerProfilePictureUrl || '',
                      },
                  ]
                : [],
        children: [],
        groupLeader: Boolean(m.groupLeader),
        partnerGivenName: m.partnerGivenName,
        partnerFamilyName: m.partnerFamilyName,
        partnerProfilePictureUrl: m.partnerProfilePictureUrl,
    };
}
